import React from 'react';

import { Heading } from '../../Common/Heading';
import { SectionContent } from './SectionContent';

export const HoldDownBrackets = () => {
  return (
    <SectionContent>
      <Heading>Hold down brackets</Heading>
    </SectionContent>
  );
};
